import React from 'react';
import PropTypes from 'prop-types';

import { translate } from 'react-i18next';

import Radiobutton from '../../Input/Radiobutton';
import Button from '../../Input/Button';

import './index.less';

export class SessionPrivacy extends React.Component {
    static displayName = 'Module.UserSettings.SessionPrivacy';  

    static propTypes = {
        t: PropTypes.func,
        invalidateAllTrainingShareLinks: PropTypes.func,
        isInvalidateAllTrainingShareLinksSuccess: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {
            isInvalidateAllInProgress: false
        };
    }

    componentWillReceiveProps(props) {
        this.setState({
            isInvalidateAllInProgress: this.state.isInvalidateAllInProgress && props.isInvalidateAllTrainingShareLinksSuccess
        });
    }

    invalidateAllTrainingShareLinks = () => {
        this.setState({
            isInvalidateAllInProgress: true
        });
        this.props.invalidateAllTrainingShareLinks();
    }

    render() {
        const { t } = this.props;

        return (
            <div>
                <div className="row">
                    <div className="control-group col-md-12 ">
                        <div className="col-md-3 label-wrapper">
                            <div className="left-label">
                                {t('settings:privacy.change_to_match_current_setting.title')}
                            </div>
                        </div>
                        <div className="controls col-md-7">
                            <Button onClick={() => this.invalidateAllTrainingShareLinks()} disabled={this.state.isInvalidateAllInProgress} className="btn settings-btn-basic" id="invalidateAllTrainingShareLinks">{t(['settings:privacy.change_to_match_current_link_share_setting.button'])}</Button>
                            <div className="info_text">
                                {t('settings:privacy.change_to_match_current_link_share_setting.text')}&nbsp;
                                {t('settings:privacy.change_to_match_current_link_share_setting.text2')}
                            </div>
                            <p className="help-block"/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate(['common', 'settings'], {wait: true})(SessionPrivacy);



// WEBPACK FOOTER //
// ./src/UserSettings/components/PrivacyView/SessionsPrivacy/index.jsx